export default __webpack_public_path__ + "static/media/objectActive.dd152dd4.png";